import { formatDate } from './formatDate';

export const getInvoicesFromSelectedRows = (selectedRowData) => {
  const finalInvoices = selectedRowData?.reduce((acc, invoice) => {
    const { patient_id, dateofservice, last_applied } = invoice;
    const groupKey = patient_id ?? `no_patient_${invoice.id}`;

    if (!acc?.[groupKey]) {
      acc[groupKey] = {
        ...invoice,
        total_amount: 0,
        amount_paid: 0,
        invoice_balance: 0,
        discount: 0,
        procedures: [],
        packages: [],
        products: [],
        tax: 0,
        internal_invoice_ids: [],
        created_at: invoice?.created_at,
        dateofservice,
        write_off: 0,
        show: true,
        aeob: invoice?.aeob ?? false
      };
    }

    const patientInvoice = acc[groupKey];

    const balance = invoice?.invoice_balance ?? invoice?.balance ?? 0;

    patientInvoice.internal_invoice_ids.push(invoice.id);
    patientInvoice.id = invoice.id;
    patientInvoice.patient = invoice.patient;
    patientInvoice.total_amount += balance;
    patientInvoice.amount_paid += invoice.amount_paid;
    patientInvoice.invoice_balance += balance;
    patientInvoice.tax += invoice?.tax;
    patientInvoice.write_off += invoice?.write_off;
    patientInvoice.aeob = patientInvoice.aeob || (invoice?.aeob ?? false);

    // Assign discount from invoice (amount in cents); default to 0 if not provided
    if (invoice.discount !== undefined && invoice.discount !== null) {
      patientInvoice.discount += invoice.discount;
    }

    invoice?.procedures?.length > 0 &&
      patientInvoice.procedures.push(
        ...invoice.procedures.map((procedure) => ({
          ...procedure,
          dateofservice: procedure.dateofservice || invoice.dateofservice,
          last_applied,
          invoiceId: invoice.id,
          invoiceStatus: procedure.invoiceStatus || invoice.status,
          show: true
        }))
      );
    invoice?.products?.length > 0 &&
      patientInvoice.products.push(
        ...invoice.products.map((product) => ({
          ...product,
          dateofservice: product.dateofservice || invoice.dateofservice,
          invoiceId: invoice.id,
          invoiceStatus: product.invoiceStatus || invoice.status,
          show: true
        }))
      );
    invoice?.packages?.length > 0 &&
      patientInvoice.packages.push(
        ...invoice.packages.map((pkg) => ({
          ...pkg,
          dateofservice: pkg.dateofservice || invoice.dateofservice,
          invoiceId: invoice.id,
          invoiceStatus: pkg.invoiceStatus || invoice.status,
          show: true
        }))
      );
    patientInvoice.created_at = patientInvoice?.created_at || formatDate({ data: new Date() });
    patientInvoice.dateofservice =
      patientInvoice?.dateofservice || formatDate({ data: new Date() });

    return acc;
  }, {});

  return Object.values(finalInvoices);
};
